module.exports = __webpack_public_path__ + "9aa36461933cb2040a1910dd474549ec.png";